"use strict";
exports.__esModule = true;
var core_1 = require("@tiptap/core");
exports["default"] = core_1.Extension.create({
    name: "enter",
    addKeyboardShortcuts: function () {
        var _this = this;
        return {
            "Mod-Enter": function () { return _this.editor.chain().focus().insertContent("<br>").run(); },
            "Enter": function () { return false; }
        };
    }
});
